import React, { useEffect, useState } from "react"
import { Link, useLocation, Redirect } from "react-router-dom";
import { connect } from "react-redux";
import { Space, Button, Input, Popconfirm, notification } from "antd"
import { EditOutlined, PlusOutlined, SearchOutlined, DeleteOutlined } from "@ant-design/icons"
import _ from 'lodash'

/* CUSTOM COMPONENT */
import Header from "../../../component/Header/Header"
import { PageContainer, Xpagination, Xtable } from "../../../component/Xcomponent"

/* ACTION */
import { getModuleList, getModuleListReset } from '../../../action/getModuleListAction'
import { deleteModule, deleteModuleReset } from '../../../action/deleteModuleAction'

/* OTHERS */
import { checkRights } from '../../../utils'


const ModuleMasterList = (props) => {
    /* VARIABLES */
    const {
        getModuleList, getModuleListReset, getModuleListState,
        deleteModule, deleteModuleReset, deleteModuleState,
    } = props
    const search = useLocation().search;
    const page = new URLSearchParams(search).get('page');
    const [tableData, setTableData] = useState([])
    const [refresh, setRefresh] = useState(0)
    const [searchText, setSearchText] = useState({})
    const [redirect, setRedirect] = useState(["", false])

    const [pagination, setPagination] = useState({
        page: page ? page : 1,
        records: 20,
    })

    const handleSearch = (selectedKeys, confirm, dataIndex) => {
        confirm()
        setSearchText({
            ...searchText,
            [dataIndex]: selectedKeys[0]
        })
    }

    const handleReset = (clearFilters, dataIndex) => {
        let remainSearch = _.omit(searchText, [dataIndex])
        clearFilters()
        setSearchText(remainSearch)
    }


    const getColumnSearchProps = (dataIndex, name) => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
            <div style={{ padding: 8 }}>
                <Input
                    placeholder={`Search ${name}`}
                    value={selectedKeys[0]}
                    onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                    onPressEnter={() => [handleSearch(selectedKeys, confirm, dataIndex), setPagination({ ...pagination, ['page']: 1 })]}
                    style={{ marginBottom: 8, display: 'block' }}
                />
                <Space>
                    <Button
                        type="primary"
                        onClick={() => [handleSearch(selectedKeys, confirm, dataIndex), setPagination({ ...pagination, ['page']: 1 })]}
                        icon={<SearchOutlined />}
                        size="small"
                        style={{ width: 90 }}
                    >
                        Search
                    </Button>
                    <Button onClick={() => handleReset(clearFilters, dataIndex)} size="small" style={{ width: 90 }}>
                        Reset
                    </Button>
                </Space>
            </div>
        ),
        filterIcon: filtered => <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />,
    });



    const columns = [
        {
            title: 'Name',
            dataIndex: 'name',
            key: 'name',
            ...getColumnSearchProps('name', 'Name')
        },
        {
            title: 'Key',
            dataIndex: 'key',
            key: 'key',
            ...getColumnSearchProps('key', 'Key')
        },
        // {
        //     title: 'Action',
        //     dataIndex: 'action',
        //     key: 'action',
        //     render: (action) => (
        //         <Space size="small">
        //             {checkRights("module", "edit") &&
        //                 <Link to={`/module/save/${action.id}`}><Button size="small" shape="circle" icon={<EditOutlined />} /></Link>
        //             }
        //             {checkRights("module", "delete") &&
        //                 <Popconfirm
        //                     title="Are you sure to delete this item?"
        //                     onConfirm={() => deleteModule({ id: action.id })}
        //                     okText="Delete"
        //                     cancelText="Cancel"
        //                     okType="danger"
        //                 >
        //                     <Button size="small" shape="circle" icon={<DeleteOutlined />} />
        //                 </Popconfirm>
        //             }
        //         </Space >
        //     )
        // },
    ];
    /* CALLBACKS */

    useEffect(() => {
        getModuleList({
            dropDownList: "",
            page: pagination.page,
            records: pagination.records,
            ...searchText
        })
        setRedirect([true, `/module/list?page=${pagination.page}`])

    }, [pagination, refresh, searchText])

    useEffect(() => {
        return (() => {
            getModuleListReset()
            deleteModuleReset()
        })
    }, [])

    useEffect(() => {
        if (deleteModuleState.apiState === "success") {
            notification["success"]({
                message: "Delete Records Successfully"
            })
            deleteModuleReset()
            getModuleList({ dropDownList: "" })
        }
        if (deleteModuleState.apiState === "error") {
            notification["error"]({
                message: "Something went wrong"
            })
            deleteModuleReset()
        }
    }, [deleteModuleState])


    useEffect(() => {
        if (getModuleListState.apiState === "success") {
            let tableData = []
            getModuleListState.list.map((row, index) => {
                tableData.push(
                    {
                        key: row.key,
                        name: row.name,
                        action: { id: row._id }
                    }
                )
            })
            setTableData(tableData)
        }
    }, [getModuleListState])

    return (
        <>
            {redirect[0] &&
                <Redirect to={redirect[1]} />}
            <Header
                title="Module List"
                // rightChildren={checkRights("module", "add") && <Link to="/module/save" ><Button type="primary" ><PlusOutlined />New</Button></Link>}
            />
            <PageContainer>
                {getModuleListState.apiState === "error" &&
                    <div style={{ height: 500, display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center" }} >
                        <p>{getModuleListState.message}</p>
                        <Button type="primary" onClick={() => setRefresh(refresh + 1)} >TRY AGAIN</Button>
                    </div>
                }

                {getModuleListState.apiState !== "error" &&
                    <>
                        <Xtable columns={columns} dataSource={tableData} pagination={false} scroll={{ x: 768 }}
                            loading={getModuleListState.apiState === "loading"}
                        />
                        <Xpagination
                            pageSizeOptions={['25', '50', '100', '500']}
                            showSizeChanger
                            total={getModuleListState.pagination?.total_records}
                            onChange={(page, pageSize) => setPagination({ page: page, records: pageSize })}
                            current={pagination.page}
                            defaultPageSize={pagination.records}
                            showTotal={(total, range) => `${range[0]}-${range[1]} of ${total} items`}
                        />
                    </>
                }
            </PageContainer>
        </>
    )
}
const mapStateToProps = (state) => ({
    getModuleListState: state.getModuleList,
    deleteModuleState: state.deleteModule,

})
const mapDispatchToProps = (dispatch) => ({
    getModuleList: (params) => dispatch(getModuleList(params)),
    getModuleListReset: () => dispatch(getModuleListReset()),
    deleteModule: (params) => dispatch(deleteModule(params)),
    deleteModuleReset: () => dispatch(deleteModuleReset()),
})

export default connect(mapStateToProps, mapDispatchToProps)(ModuleMasterList)
